import { UsersService } from '@shared/services/users/users.service';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ElementRef,
  ViewEncapsulation,
  ChangeDetectorRef
} from '@angular/core';
import { ICompany } from '@collections/companies/interfaces/company.interface';
import { StandService } from 'app/stand/stand.service';
import { IconsLoader } from '@shared/services/icons/icons-loader.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UserRolesEnum } from '@collections/users/enums/user-roles.enums';
import { Platform } from '@angular/cdk/platform';
import { take } from 'rxjs';
import { animate, query, state, style, transition, trigger } from '@angular/animations';
import { AsyncPipe } from '@angular/common';
import { InfoBarComponent } from './components/info-bar/info-bar.component';
import { RenderIfDirective } from '../shared/directives/render-if.directive';
import { RouterOutlet } from '@angular/router';
import { DataSharingService } from './components/data-sharing.service';

@UntilDestroy()
@Component({
    selector: 'stand',
    templateUrl: './stand.component.html',
    styleUrls: ['./stand.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('routeAnimations', [
            transition('ready => void', [
                // Create a sequence of animations.
                query('router-outlet ~ *', [style({}), animate(800, style({}))], {
                    optional: true
                })
            ])
        ]),
        trigger('descriptinonExpanded', [
            state('true', style({
                transform: 'translateY(var(--e-expanded-desc-ty))'
            })),
            state('false', style({
                transform: 'translateY(0)'
            })),
            transition('false <=> true', [
                animate('300ms')
            ])
        ]),
    ],
    standalone: true,
    imports: [RouterOutlet, RenderIfDirective, InfoBarComponent, AsyncPipe]
})
export class StandComponent implements OnInit {
  lockedCollapsed = false;
  company: ICompany;
  routerAnimation = 'void';
  showOverlay: boolean;
  constructor(
    public elementRef: ElementRef,
    public standService: StandService,
    private iconsLoader: IconsLoader,
    private usersService: UsersService,
    private platform: Platform,
    private cd: ChangeDetectorRef,
    private dataSharingService: DataSharingService
  ) {
    this.iconsLoader.load('stand');
    this.iconsLoader.load('sectors');
    this.iconsLoader.load('social');
    this.iconsLoader.load('halls');

    if (this.usersService.isInRole([UserRolesEnum.admin, UserRolesEnum.stand_admin])) {
      this.iconsLoader.load('edit');
    }
    this.dataSharingService.overlayVisible$.subscribe(isVisible =>{
      this.showOverlay = isVisible;
    })
  }

  ngOnInit(): void {
    this.standService.getCurrentCompany()
    .pipe(
      take(1)
    )
    .subscribe(company => {
      this.company = company;
    });

    this.standService.$onSlideStand
    .pipe(
      untilDestroyed(this)
    )
    .subscribe((opt: any) => {
      this.routerAnimation = 'ready';
      this.cd.detectChanges();
    });
  }

}
